import { render, staticRenderFns } from "./designedit.vue?vue&type=template&id=25ce5461&scoped=true&"
import script from "./designedit.vue?vue&type=script&lang=js&"
export * from "./designedit.vue?vue&type=script&lang=js&"
import style0 from "./designedit.vue?vue&type=style&index=0&id=25ce5461&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ce5461",
  null
  
)

export default component.exports